<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div >
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-body modal-content">                     
                            <div class="">
                                <div class="title_block">
                                    <h3 class="mb-0 font-active">{{ title }} : <span>{{ item.includes('ct. tw.') ? item : item + ' ct. tw.' }}</span> </h3>
                                    <span @click="notOpenModal"><SvgHeaderSvg type="close" class="largesvg" /></span>
                                </div>
                                <div class="mt-3">

                                    <div class="image_block my-3 text-center">
                                        <img src="/settingactive/totalctwt.svg" width="150" height="72">

                                        <p class="mb-0 title">{{ item.includes('ct. tw.') ? item : item + ' ct. tw.' }}</p>
                                    </div>
                                    <!-- <p class="mb-0" v-if="title !=='Min. Total Carat'">Accent diamonds are smaller diamonds that are placed around or next to the centerstone in a {{ finalModuleSubType  }} to enhance its look. Their total carat weight is the sum of the weight of all the side stones on the {{ finalModuleSubType }}. 
                                    </p> -->
                                    <p class="mb-0" v-if="title !=='Min. Total Carat'">Minimum total carat refers to the total carat weight of all the diamonds featured in a {{ $t('jewelry') }} piece, including the smaller accent stones. 
                                    </p>
                                    <p class="mb-0" v-if="title ==='Min. Total Carat'">Minimum total carat refers to the minimum sum of the diamonds in an {{ changeType }}. 
                                    </p>
                                    <!-- <p class="mt-1 mb-0 text">*The number of diamonds may vary as per the total carat weight and the {{ changeType }} size.
                                    </p> -->
                                        <!-- dynamic Seven & FIVE Stone -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Teleport>
        </div>
    </div>
</template>

<script setup>
    const flagShowModal = ref(false);
    const totalWeight = ref(null);
    const props = defineProps(['item', 'title','detailData','moduleSubType','ringBox'])

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
    const emit = defineEmits(['close']);

    const finalModuleSubType = computed(() => {
        if (props.moduleSubType && props?.moduleSubType !== '') {
            // If moduleSubType is available and not empty
            return props.moduleSubType;
        } else if (props?.detailData && props.detailData !== '') {
            // If detailData is available and not empty
            return props.detailData;
        } else {
            // Fallback to a default value, e.g., ''
            return 'ring';
        }
    });
    
    // seven and FIVE only
    const changeType = props.detailData
    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = totalWeight.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = totalWeight.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };
</script>



<style scoped>
.largesvg {
    transform: scale(1.3);
    }

.img_box{
    height: 130px;
}

.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}
.text{
    font-size: 14px;
    font-style: italic;
    color: #909090;
}
.title_block{
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    text-transform: capitalize;
}

p {
    font-size: 16px;
    color: #606060;
}
.title_block span {
    cursor: pointer;
    color: var(--green);
}
h3{
    font-size: 22px;
}
.m-info {
    margin: 10px 0;
}
.title{
    text-transform: capitalize;
    color: #668b84;
    font-size: 16px;

}
@media(max-width: 767px){
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }
    .text{
        font-size: 12px;
    }
}
</style>
